class GrupoParecerEnum {

    constructor(descricao, value) {
        this.descricao = descricao;
        this.value = value;
    }

    static fromValue(value) {
        return Object.values(GrupoParecerEnum).find(status => status.value === value);
    }

    static fromDescricao(descricao) {
        return Object.values(GrupoParecerEnum).find(status => status.descricao === descricao);
    }
}


GrupoParecerEnum.TOTAL = new GrupoParecerEnum("Total", 1);
GrupoParecerEnum.ALMOXARIFADO = new GrupoParecerEnum("Almoxarifado", 2);
GrupoParecerEnum.SOLICITACAO_MOVIMENTACAO_IBP = new GrupoParecerEnum("Solicitação de Movimentação IBP", 14);
GrupoParecerEnum.MOVIMENTACAO_IBC = new GrupoParecerEnum("Movimentação IBC", 15);


export default GrupoParecerEnum;